var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5443 7.76724C26.1651 8.69672 25.4818 9.24424 23.7804 10.7849C22.3237 12.0964 22.3496 12.0836 21.9371 11.6635C21.0864 10.7594 17.9668 9.94453 17.0774 10.4156C16.652 10.6321 16.7036 11.065 17.1548 11.065C18.3793 11.0777 19.5137 11.638 20.4805 12.4401C21.3441 13.1659 21.3441 13.1277 20.1196 14.3245C18.8047 15.5978 16.9356 17.6987 15.8915 19.0611L15.0923 20.1052L14.422 19.1248C12.8365 16.7819 11.1221 15.6233 10.0651 16.1708C9.67836 16.3745 9.74282 16.5019 10.9029 17.7115C11.9213 18.7683 12.9783 20.2708 13.7259 21.735C14.3317 22.9192 15.8271 22.9192 16.8454 21.213C17.5802 19.9779 19.475 17.6224 21.0347 16.018L22.4269 14.5792L22.762 15.3177C25.7526 21.926 18.4567 29.5783 12.3209 26.2679C6.05618 22.881 7.47411 12.02 14.306 11.0523C15.6466 10.8613 15.6723 10.4156 14.3446 10.2501C10.9158 9.79174 6.53313 13.8025 6.06908 17.8007C5.19253 25.4275 12.8107 30.3933 20.2613 27.07C24.7858 25.0582 26.8998 17.8261 24.1026 14.0063C23.8964 13.7262 23.7288 13.4588 23.7288 13.3951C23.7288 13.1277 26.0362 11.0905 28.4853 9.2315C31.2438 7.1306 29.813 6.23931 27.5443 7.76724Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checkedIcon.96f339bd1df285b35a4e7989f1597160.svg";
export { ForwardRef as ReactComponent };